// extracted by mini-css-extract-plugin
var _1 = "BorderedIcon-module__container--yFILb";
var _2 = "BorderedIcon-module__topic--wvVNJ";
export { _1 as "container", _2 as "topic" }
